import { useContext, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { UserContext } from '../context/UserContext';
import API from '../config/axiosConfig';
import Loader from '../components/Loader';
import LoginPageLink from './LoginPageLink';
import './AuthStatusPage.scss';

// /register?token= from the cutoff on (docs/Auth-Flows.md, "Invitation"): no
// Mashlom page, straight to Microsoft's sign-up page with the invited email
// filled in. The email link cannot point at Microsoft itself: MSAL has to start
// the sign-in in this browser. Microsoft's page cannot lock the email; signing up
// with another one is a plain sign-in without the invitation (the server decides).
export default function InvitationSignup() {
  const { loginWithEntra } = useContext(UserContext);
  const location = useLocation();
  const token = new URLSearchParams(location.search).get('token');
  const [error, setError] = useState('');
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    if (!token) {
      setError('הקישור להזמנה אינו שלם. פתחו אותו שוב מהמייל.');
      return;
    }
    API.get(`/api/users/handle-invitation/${token}`, { handlingErrorLocally: true })
      .then(response => loginWithEntra({
        intent: 'invitation',
        invitationToken: token,
        loginHint: response.data?.email || null,
        prompt: 'create',
      }))
      .catch((startError) => {
        console.error('Opening the invitation sign-up failed:', startError);
        setError(startError.response?.data?.error?.hebMessage || 'לא הצלחנו לפתוח את ההזמנה. נסו שוב מהמייל.');
      });
  }, [token, loginWithEntra]);

  if (!error) return <Loader isLoading={true} />;

  return (
    <div className="auth-status-page" dir="rtl">
      <h1>הזמנה למשלום</h1>
      <p role="alert">{error}</p>
      <LoginPageLink />
    </div>
  );
}
